import React, { useRef } from 'react';
import PartnerHeroSection from '../../../components/landingPage/PartnerPage/PartnerHeroSection';
import PartnerReachSection from '../../../components/landingPage/PartnerPage/PartnerReachSection';
import PartnerWhyChooseSection from '../../../components/landingPage/PartnerPage/PartnerWhyChooseSection';
import PartnerLevelsSection from '../../../components/landingPage/PartnerPage/PartnerLevelsSection';
import PartnerStepsSection from '../../../components/landingPage/PartnerPage/PartnerStepsSection';
import PartnerLogosSection from '../../../components/landingPage/PartnerPage/PartnerLogosSection';
import PartnerCtaSection from '../../../components/landingPage/PartnerPage/PartnerCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const LandingHomePartner = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <PartnerHeroSection />
            <PartnerReachSection />
            <PartnerWhyChooseSection />
            <PartnerLevelsSection />
            <PartnerStepsSection />
            <PartnerLogosSection />
            <PartnerCtaSection />
        </div>
    );
};

export default LandingHomePartner;
